/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import warning from "./warning";

type containsType = (element: string | any[], subject: any) => boolean;

const safeInclude: containsType = (element, subject) => {
  if (typeof element !== "string" && !Array.isArray(element)) {
    warning(
      `contains element must be a string or an array ${JSON.stringify(
        element,
        null,
        2
      )}`
    );
    return false;
  }
  return element.includes(subject);
};

export default safeInclude;
